import Vue from "vue";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import VueProgressBar from "vue-progressbar";
import VueSweetalert2 from "vue-sweetalert2";
import vSelect from "vue-select";
import { VueSpinners } from "@saeris/vue-spinners";
import * as VueGoogleMaps from "vue2-google-maps";
import Vuelidate from "vuelidate";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VuePivottable from "vue-pivottable";


import "vue-pivottable/dist/vue-pivottable.css";
import "sweetalert2/dist/sweetalert2.min.css";
import "vue-select/dist/vue-select.css";

/* Evitar overlay por "ResizeObserver loop" (error conocido e inofensivo) */
const _onError = window.onerror;
window.onerror = function (msg, url, lineNo, columnNo, err) {
  if (typeof msg === "string" && msg.includes("ResizeObserver loop")) return true;
  return _onError ? _onError.apply(this, arguments) : false;
};

Vue.config.productionTip = false;

if (typeof window !== "undefined" && window.ResizeObserver && !window.__resizeObserverPatched) {
  window.__resizeObserverPatched = true;
  const OriginalResizeObserver = window.ResizeObserver;
  window.ResizeObserver = class extends OriginalResizeObserver {
    constructor(callback) {
      let rafId = 0;
      const wrappedCallback = (entries, observer) => {
        if (rafId) {
          cancelAnimationFrame(rafId);
        }
        rafId = requestAnimationFrame(() => {
          callback(entries, observer);
        });
      };
      super(wrappedCallback);
    }
  };
}

const options = {
  color: "#6c757d",
  thickness: "6px",
  autoRevert: true,
  transition: {
    speed: "0.3s",
    opacity: "0.4s",
    termination: 400,
  },
  inverse: false,
};

const optionsSwal = {
  confirmButtonColor: "#6c757d",
  cancelButtonColor: "#00529c",
};

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyBNGjrRTjr5gBlJINPoMU6UvDw2Dn62WWE",
    libraries: ["places", "geometry", "visualization"],
  },
});

Vue.use(VueProgressBar, options);
Vue.use(VueSweetalert2, optionsSwal);
Vue.use(VueSpinners);
Vue.use(VuePivottable);
Vue.use(Vuelidate);
Vue.component('date-picker', DatePicker);
Vue.component("v-select", vSelect);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
